import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Retorna uma função que prefixa caminhos com o locale atual da URL.
 * Lê o prefixo diretamente de useLocation() — sempre sincronizado com
 * a rota atual, sem depender do estado assíncrono do i18n.
 *
 * pt-BR: sem prefixo   → localePath('/projects') = '/projects'
 * en-US: prefixo /en   → localePath('/projects') = '/en/projects'
 * es-ES: prefixo /es   → localePath('/projects') = '/es/projects'
 *
 * Caso especial '/':
 *   pt-BR → '/'
 *   en-US → '/en'
 *   es-ES → '/es'
 */
export function useLocalePath() {
  const location = useLocation()

  return useCallback((path: string) => {
    const prefix =
      location.pathname.startsWith('/en') ? '/en' :
      location.pathname.startsWith('/es') ? '/es' : ''

    if (path === '/') return prefix || '/'
    return `${prefix}${path}`
  }, [location.pathname])
}
